export default "__VITE_ASSET__oQdiw_sz__"